import React, { useEffect } from 'react'
import './tab.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppContext } from '../../../../common/context';
import { renameCategory } from '../../../../common/utils';

function InsightTab() {
  const navigation = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const {insightTab, tabHandler} = useAppContext();

  const activeA = insightTab === 'success'?'active':'';
  const activeB = insightTab === 'intel'?'active':'';
  const activeC = insightTab === 'whats'?'active':'';
  const clickHandler = tab => {
    tabHandler(tab);
    if(tab === 'success'){
      navigation("/success-story")
    } else if(tab === 'intel'){
      navigation("/intel-ideas")
    } else {
      navigation("/whats-news")
    }
  }

  useEffect(() => {
    let page = currentPath.split("/")[1]
    const cat = renameCategory(page);
    tabHandler(cat);
  
  }, [currentPath])
  
  return (
    <div className="insights-wrapper">
        <div className="insights-categories">
          <div onClick={() => clickHandler('success')}>
            <div className={`category btn-success-story ${activeA}`}>
              <span className="tab-text">Success Stories</span>
            </div>
          </div>
          <div onClick={() => clickHandler('intel')}>
            <div className={`category btn-intel-ideas ${activeB}`}>
              <span className="tab-text">Intel &amp; Ideas</span></div>
          </div>
          <div onClick={() => clickHandler('whats')}>
            <div className={`category btn-whats-news ${activeC}`}>
              <span className="tab-text">What's New(s)</span></div>
          </div>
        </div>
      </div>

  )
}

export default InsightTab